import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	createCalendarSuccessTitle: {
		id: 'servicedesk-sla-settings.common.sla-config-action-flags.create-calendar-success-title',
		defaultMessage: 'Calendar created!',
		description: 'title label for successfully adding a new calendar',
	},
	editCalendarSuccessTitle: {
		id: 'servicedesk-sla-settings.common.sla-config-action-flags.edit-calendar-success-title',
		defaultMessage: 'Calendar edited!',
		description: 'title label for successfully editing an existing calendar',
	},
	createCalendarSuccessDescription: {
		id: 'servicedesk-sla-settings.common.sla-config-action-flags.create-calendar-success-description',
		defaultMessage: 'Calendar "{calendarName}" created successfully!',
		description: 'description label for successfully adding a new calendar',
	},
	editCalendarSuccessDescription: {
		id: 'servicedesk-sla-settings.common.sla-config-action-flags.edit-calendar-success-description',
		defaultMessage: 'Calendar "{calendarName}" edited successfully!',
		description: 'description label for successfully editing an existing calendar',
	},
	calendarSaveFailedTitle: {
		id: 'servicedesk-sla-settings.common.sla-config-action-flags.calendar-save-failed-title',
		defaultMessage: 'We are unable to save the calendar',
		description: 'label for calendar save failed title',
	},
	calendarSaveFailedDescription: {
		id: 'servicedesk-sla-settings.common.sla-config-action-flags.calendar-save-failed-description',
		defaultMessage: 'Try again later',
		description: 'label for calendar save failed description',
	},
	calendarImportPartialFailureTitle: {
		id: 'servicedesk-sla-settings.common.sla-config-action-flags.calendar-import-partial-failure-title',
		defaultMessage: 'Some of your holidays didn’t import',
		description: 'label for calendar import partial failure title',
	},
	calendarImportPartialFailureDescription: {
		id: 'servicedesk-sla-settings.common.sla-config-action-flags.calendar-import-partial-failure-description',
		defaultMessage: 'Check which holidays are missing and add them in manually.',
		description: 'label for calendar import partial failure description',
	},
	calendarImportParserFailureTitle: {
		id: 'servicedesk-sla-settings.common.sla-config-action-flags.calendar-import-parser-failure-title',
		defaultMessage: 'We can’t use that file format',
		description: 'label for calendar import failed title',
	},
	calendarImportParserFailureDescription: {
		id: 'servicedesk-sla-settings.common.sla-config-action-flags.calendar-import-parser-failure-description',
		// eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
		defaultMessage: 'Try importing your holidays using an ICS file.',
		description: 'label for calendar import failed description',
	},
	calendarImportParserServerFailureTitle: {
		id: 'servicedesk-sla-settings.common.sla-config-action-flags.calendar-import-parser-server-failure-title',
		defaultMessage: 'We couldn’t import your file',
		description: 'label for server side calendar import failed title',
	},
	calendarImportParserServerFailureDescription: {
		id: 'servicedesk-sla-settings.common.sla-config-action-flags.calendar-import-parser-server-failure-description',

		defaultMessage: 'Select ‘Import’ to try uploading your file again.',
		description: 'label for server side calendar import failed description',
	},
	calendarImportSuccessTitle: {
		id: 'servicedesk-sla-settings.common.sla-config-action-flags.calendar-import-success-title',
		defaultMessage: 'Success',
		description: 'label for calendar import success title',
	},
	calendarImportSuccessDescription: {
		id: 'servicedesk-sla-settings.common.sla-config-action-flags.calendar-import-success-description',
		defaultMessage: 'Your holidays have been imported. ',
		description: 'label for calendar import success description',
	},
	calendarDismissWithGotIt: {
		id: 'servicedesk-sla-settings.common.sla-config-action-flags.calendar-dismiss-with-got-it',
		defaultMessage: 'Got it',
		description: 'label to dismiss the calendar flags',
	},
	deleteCalendarSuccessTitle: {
		id: 'servicedesk-sla-settings.common.sla-config-action-flags.delete-calendar-success-title',
		defaultMessage: 'Calendar deleted!',
		description: 'title label for calendar delete success',
	},
	deleteCalendarSuccessDescription: {
		id: 'servicedesk-sla-settings.common.sla-config-action-flags.delete-calendar-success-description',
		defaultMessage: 'Calendar "{calendarName}" deleted successfully!',
		description: 'description label for calendar delete success',
	},
	timeMetricSaveSuccessTitle: {
		id: 'servicedesk-sla-settings.common.sla-config-action-flags.time-metric-save-success-title',
		defaultMessage: '{timeMetricName} saved',
		description: 'title label for successfully adding a new calendar',
	},
});
